import { Component, EventEmitter, input, InputSignal, Output } from '@angular/core';

import { Accessible } from '../../../../shared/mixins/accessible.mixin';
import {
    LiquidViewerAnnotation,
} from '../../../liquid-viewer.models';


@Component({
    selector: 'meta-liquid-annotations-list',
    templateUrl: './liquid-annotations-list.component.html',
    styleUrls: ['./liquid-annotations-list.component.css']
})
export class LiquidAnnotationsListComponent extends Accessible {

    @Output() doClose = new EventEmitter();
    @Output() openAnnotation = new EventEmitter<LiquidViewerAnnotation>();
    @Output() deleteAnnotation = new EventEmitter<LiquidViewerAnnotation>();
    @Output() createBookmark = new EventEmitter();
    @Output() createClipping = new EventEmitter();

    $annotations: InputSignal<LiquidViewerAnnotation[]> = input.required({ alias: 'annotations' });
    $pageBookmark = input(undefined, { alias: 'pageBookmark' });

    onClose(): void {
        this.doClose.emit();
    }
}